// modules
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// imports
import { ButtonRadio } from './button-radio.component';
import { ButtonRadioGroup } from './button-radio-group.component';
import { ButtonRadioChange } from './button-radio-change.class';


// exports
export {
  ButtonRadio,
  ButtonRadioGroup,
  ButtonRadioChange
};

@NgModule({
  declarations: [
    ButtonRadio,
    ButtonRadioGroup
  ],
  exports: [
    ButtonRadio,
    ButtonRadioGroup
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class ButtonRadioModule { }
